export default __webpack_public_path__ + "static/media/japan-iphone.5546a748.gif";